import clsx from 'clsx'
import type { ReactNode } from 'react'
import { HedvigSymbol } from '../HedvigSymbol/HedvigSymbol'
import { tokens } from '../../theme/tokens.css'
import { badge, wrapper } from './HedvigAppIcon.css'

type HedvigAppIconProps = {
  size?: string
  radius?: keyof typeof tokens.radius
  badgeIcon?: ReactNode
  badgeColor?: string
  className?: string
}

export function HedvigAppIcon({
  size = '4rem',
  radius = 'xl',
  badgeIcon,
  badgeColor = tokens.colors.signal.green.element,
  className,
}: HedvigAppIconProps) {
  return (
    <div
      className={clsx(wrapper, className)}
      style={{ width: size, height: size, borderRadius: tokens.radius[radius] }}
    >
      <HedvigSymbol color="white" size={`calc(${size} * 0.625)`} />
      {badgeIcon && (
        <div className={badge} style={{ backgroundColor: badgeColor }}>
          {badgeIcon}
        </div>
      )}
    </div>
  )
}
